export default {
  validateEmail: email => {
    const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return res.test(String(email).toLowerCase());
  },

  parseGamepassID: url => {
	return /https:\/\/.*?\.roblox\.com\/game-pass\/([0-9]*).*?/.exec(url)
  },

  recommision: i => Math.round(i*1/0.7),
  
  takeCommision: i => Math.round(i*0.7),

  closeEnough: (a, b) => Math.abs(Math.max(a, b)/Math.min(a, b)) < 1.005,

  // div = times
  // X   = ceil
  splitNumber: (number, div) => {
	const times = number / div;
	const ceil = Math.ceil(times);
	const part = number / ceil;
	return {
	  div: part,
	  times: ceil
	};
  }
}
